﻿import './Services.scss';
﻿import '../Shared/Service/Service.scss';

import $ from 'jquery';

$( document ).ready(function() {

    let visibleServices = {};
    let filters = '.custom-select ul li';
    let services = '.services-list .service-wrap';

    function showSelectedService(dataId) {

        let selectedServices = (dataId !== 0) ? $(services + '[data-category=' + dataId + ']') : $(services);

        selectedServices.each(function (idx, service) {
            if(idx < visibleServices[dataId] ||  window.innerWidth > 767){
                $(service).removeClass('hidden');
            }
        });

        if((selectedServices.length > visibleServices[dataId]) && window.innerWidth < 768){
            $('.js-add-more').show();
        } else {
            $('.js-add-more').hide();
        }
    }

    function selectFilter(el) {

        let id = el.data('id');
        $(filters).removeClass('selected');
        $(el).addClass('selected');

        $(services).each(function (idx, service) {
            $(service).addClass('hidden');
        });

        showSelectedService(id);

        $('.custom-selected').text($(el).text());
    }

    //open menu on mobile
    $('.custom-select').click(function (e) {
        e.stopPropagation();
        $(this).toggleClass('open');
    });

    $(window).click(function () {
        let el = $('.custom-select');
        if (el.hasClass('open')) {
            el.removeClass('open');
        }
    });

    //filter services
    $(filters).click(function () {
        let el = $(this);
        selectFilter(el);
    });

    //add more btn
    $('.js-add-more').click(function () {
        let dataId = $(filters + ".selected").data("id");

        visibleServices[dataId] += 2;

        showSelectedService(dataId);
    });

    $(window).resize(function () {
        let el = $(filters + ".selected");
        selectFilter(el);
    });

    //set for each filter visibleReviews
    $(filters).each(function (idx, filter) {
        let dataId = $(filter).data('id');
        visibleServices[dataId] = 4;
    });

    $(window).trigger('resize');
});



// WEBPACK FOOTER //
// ./Src/Services/Services.js